/**
 * Independence Day FREEDOM SALE campaign window.
 * All dates in India Standard Time (UTC+05:30). Comparison against the browser's
 * current wall-clock time — converted to IST offset — so the popup activates and
 * expires on the correct Indian calendar day regardless of visitor timezone.
 */
export const FREEDOM_CAMPAIGN = {
  code: 'FREEDOM20',
  discountPercent: 20,
  // Inclusive start (00:00:00 IST on 9 Aug 2026)
  startIso: '2026-08-09T00:00:00+05:30',
  // Inclusive end (23:59:59 IST on 19 Aug 2026)
  endIso: '2026-08-19T23:59:59+05:30',
};

/** Is the browser currently within the FREEDOM SALE window (IST)? */
export const isFreedomCampaignActive = (now = new Date()) => {
  const start = new Date(FREEDOM_CAMPAIGN.startIso).getTime();
  const end = new Date(FREEDOM_CAMPAIGN.endIso).getTime();
  const t = now.getTime();
  return t >= start && t <= end;
};
